/**
 * Seller API Service
 * Handles all API calls for seller portal functionality
 * Integrates with backend endpoints under /seller/*, /v1/seller/* and /v1/cashier/*
 */

import sellerAuthService from './SellerApis/sellerAuthService';
import sellerProductsService from './SellerApis/sellerProductsService';
import sellerCampaignsService from './SellerApis/sellerCampaignsService';
import sellerEarningRulesService from './SellerApis/sellerEarningRulesService';
import sellerRedemptionRulesService from './SellerApis/sellerRedemptionRulesService';
import sellerRewardsService from './SellerApis/sellerRewardsService';
import sellerCustomersService from './SellerApis/sellerCustomersService';
import sellerCashiersService from './SellerApis/sellerCashiersService';
import sellerCustomerTicketsService from './SellerApis/sellerCustomerTicketsService';
import sellerAnalyticsService from './SellerApis/sellerAnalyticsService';
import sellerCashierPosService from './SellerApis/sellerCashierPosService';

export const sellerApiService = {
  // ==================== Authentication ====================
  ...sellerAuthService,

  // ==================== Products ====================
  ...sellerProductsService,

  // ==================== Campaigns ====================
  ...sellerCampaignsService,

  // ==================== Earning Rules ====================
  ...sellerEarningRulesService,

  // ==================== Redemption Rules ====================
  ...sellerRedemptionRulesService,

  // ==================== Rewards ====================
  ...sellerRewardsService,

  // ==================== Customers ====================
  ...sellerCustomersService,

  // ==================== Cashiers ====================
  // List: getCashiers({ page, limit, sort, order, status }). Update/delete use sellerId from session (slice passes from profile).
  ...sellerCashiersService,

  // ==================== Customer Support Tickets ====================
  ...sellerCustomerTicketsService,

  // ==================== Analytics & Reports ====================
  ...sellerAnalyticsService,

  // ==================== Cashier POS Operations ====================
  ...sellerCashierPosService,
};

export default sellerApiService;